import {
	appVersionRaw,
	sentryReleaseAnalytics,
} from '@jepto/environments/app-version.generated';

export const environment = {
	production: false,
	staging: false,
	develop: true,
	hostName: 'https://dev.jepto.com',
	appSyncConfig: {
		graphqlEndpoint:
			'https://tufmdjuj3nfelf4xekkm5d3jz4.appsync-api.ap-southeast-1.amazonaws.com/graphql',
		customEndpoint: 'https://dev.api.jepto.com/graphql',
		eventsEndpoint: 'https://dev.event.jepto.com/event',
		region: 'ap-southeast-1',
		authenticationType: 'iam',
	},
	cognitoSettings: {
		identityPoolId: 'ap-southeast-1:33f3f013-423a-4346-9d4e-a664cbe02c19',
		UserPoolId: 'ap-southeast-1_2peJmBtUq',
		ClientId: '7jkdas9ekeminjq171u6v91uvi',
	},
	sentry: {
		enabled: true,
		dsn: 'https://38a20e46129d18839d8b43c884faf76a@o4510870850437120.ingest.us.sentry.io/4510870852403200',
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.01,
		replaysOnErrorSampleRate: 1.0,
		debug: false,
	},
	appVersion: `v${appVersionRaw}`,
	appVersionRaw,
	sentryRelease: sentryReleaseAnalytics,
	/** POST target for REPORT_VIEWED events; enable in stg before prd. */
	reportViewUrl: 'https://dev.api.app.jepto.com/report/view',
	/** Gate rollout: keep false in prd until /report/view capacity and IAM auth are verified in stg. */
	reportViewTrackingEnabled: true,
};
